export default __webpack_public_path__ + "static/media/drawdown2026.1367a21f.png";